class ShippingOptionsByLocationSerializer {
  static deSerialize(data) {
    let deSerializedData = {};
    deSerializedData = {
      textHeader: data.TextoCabezal,
      textFooter: data.TextoPie,
      shippings: [],
    };
    data.TiposDeFletes.forEach((dataLine) => {
      const item = {
        price: dataLine.CostoFlete,
        maxPrice: dataLine.CostoMaximoFlete,
        shippingTime: dataLine.HorariosEnvios,
        name: dataLine.NombreFlete,
        agencyData: [],
      };
      (dataLine.AgenciasTransporte || []).map(agencyInfo => (
        item.agencyData.push({
          name: agencyInfo.Nombre,
          extraCost: agencyInfo.ValorPiso,
        })
      ));
      deSerializedData.shippings.push(item);
    });
    return deSerializedData;
  }
}

export { ShippingOptionsByLocationSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/ShippingOptionsByLocationSerializer.js